import { Component, OnChanges, OnInit, ElementRef, ViewChild, Input, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { PieChartComponentBase } from '../base/pie-chart.base';

@Component({
    selector: 'app-article-invoice-amount',
    templateUrl: './article-invoice-amount.component.html',
    styleUrls: ['./article-invoice-amount.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ArticleInvoiceAmountComponent extends PieChartComponentBase implements OnChanges, OnInit {
  constructor() {
    super();
  }

  @Input() articles: any[];

  private readonly _markers = ['#27a69b', '#3d9fce', '#2751a7', '#673bb6', '#a426a3', '#ce8a3f', '#d2c133', '#fff'];

  private _getMarker(index: number) {
    const marker = this._markers[index];
    if (!marker) throw new Error('Missing marker');
    return marker;
  }

  private _updateView() {
    let values = this.articles.map(x => x.amount.amount);
    this.colors = this.articles.map(m => m.marker);
    this.updatePie(values);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes['articles'].firstChange) {
      this._updateView();
    }
  }

  ngOnInit() {
    let index = 0;
    this.articles.forEach(x => {
      x.marker = this._getMarker(index);
      index++;
    });
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this._updateView();
  }
}
